/* ===========================================================
   Gestion du flou + spinner sur la section recommandations
=========================================================== */
function showRecommendationsLoading() {
    const container = document.querySelector(".vv-super-cross-cart-drawer .recommendation-container");
    if (container) container.classList.add("loading");
}

function hideRecommendationsLoading(delay = 1500) {
    const container = document.querySelector(".vv-super-cross-cart-drawer .recommendation-container");
    if (container) {
        setTimeout(() => container.classList.remove("loading"), delay);
    }
}

/* ===========================================================
   Fonction principale CHECK()
=========================================================== */
function check(me, event) {
    event.preventDefault();

    /* AJOUT SPINNER ON + DISABLE BOUTON */
    const spinner = me.querySelector(".loading-overlay__spinner");
    if (spinner) spinner.classList.remove("hidden");
    me.disabled = true;

    const noDrawer = me.getAttribute("data-no-drawer") === "true";
    const DRAWER_SEL = "cart-drawer#cart-drawer, cart-drawer, #cart-drawer, .cart-drawer";

    function expandCart() {
      const drawer = document.querySelector(DRAWER_SEL);
      if (drawer) drawer.classList.add("is-expanded");
      $(".gradient").first().addClass("drawer-open");
    }

    function expandSuperCross() {
      $(".vv-super-cross-cart-drawer").addClass("is-expanded");
      $(".gradient").first().addClass("drawer-open");
    }

    function closeCart() {
      $(".vv-super-cross-cart-drawer").removeClass("is-expanded");
      const d = document.querySelector(DRAWER_SEL);
      if (d) d.classList.remove("is-expanded");
      $(".gradient").first().removeClass("drawer-open");
    }

    // Recharge un bloc et résout quand il est bien remplacé
    function reloadAndWait(selector, target, expectedText = "", timeoutMs = 1500) {
      return new Promise((resolve) => {
        const parent = document.querySelector(selector)?.parentElement;
        if (!parent) return resolve();
        const beforeHTML = parent.innerHTML;
        let done = false;

        const observer = new MutationObserver(() => {
          const now = parent.innerHTML;
          if (now !== beforeHTML && (!expectedText || now.includes(expectedText))) {
            done = true;
            observer.disconnect();
            resolve();
          }
        });

        observer.observe(parent, { childList: true, subtree: true });

        $(selector).first().load(location.href + " " + target, () => {
          if (!done) {
            observer.disconnect();
            resolve();
          }
        });

        setTimeout(() => {
          if (!done) {
            observer.disconnect();
            resolve();
          }
        }, timeoutMs);
      });
    }

    function updateCart(expectedText = "") {
      const summarySelector = "#vv-super-cross-cart-drawer #content-separator";
      return Promise.all([
        reloadAndWait(summarySelector, summarySelector, expectedText),
        reloadAndWait(".cart-count-bubble", ".cart-count-bubble"),
        reloadAndWait(".cart-drawer__footer-subtotal-amount", ".cart-drawer__footer-subtotal-amount"),
        reloadAndWait(".vv-cart-drawer__contents", ".vv-cart-drawer__contents"),
        reloadAndWait(".totals__item-value", ".totals__item-value"),
      ]);
    }

    /* ===========================================================
       Ajout au panier + mise à jour + ouverture drawer
    ============================================================ */
    function addItemAndUpdate(variantId, quantity, openDrawer = true, afterAddCallback = null) {
      if (!variantId) return;
      const formData = { items: [{ id: variantId, quantity: quantity || 1 }] };
      const btn = me;

      btn.classList.add("loading");
      showRecommendationsLoading();

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then((r) => r.json())
        .then((cart) => {
          if (cart && cart.status) return;

          updateCart().then(() => {
            setTimeout(() => {
              btn.classList.remove("loading");
              hideRecommendationsLoading(0);

              /* 🔥 AJOUT SPINNER OFF + ENABLE BOUTON */
              const spinner = btn.querySelector(".loading-overlay__spinner");
              if (spinner) spinner.classList.add("hidden");
              btn.disabled = false;

              setTimeout(() => {
                if (openDrawer && !noDrawer) expandSuperCross();
                if (afterAddCallback) setTimeout(afterAddCallback, 300);
              }, 200);
            }, 1500);
          });
        })
        .catch(() => {
          setTimeout(() => {
            btn.classList.remove("loading");
            hideRecommendationsLoading(0);

            /* 🔥 AJOUT SPINNER OFF */
            const spinner = btn.querySelector(".loading-overlay__spinner");
            if (spinner) spinner.classList.add("hidden");
            btn.disabled = false;

          }, 1500);
        });
    }

    /* ===========================================================
       Gestion fermeture du Drawer
    ============================================================ */
    $(".cart-drawer__header-close, .vv-super-cross-cart-drawer__button")
      .off("click")
      .on("click", function () {
        $("#variantPicker").hide();
        $("#main-cart-items, #main-cart-footer").show();
        $("#productUnavailable").hide();
        closeCart();
      });

    function getContextQuantity() {
      // Chercher l'input VISIBLE le plus proche du bouton cliqué
      const visibleInputs = Array.from(document.querySelectorAll(".quantity__input"))
        .filter(input => {
          const style = window.getComputedStyle(input);
          return style.display !== 'none' && style.visibility !== 'hidden';
        });

      if (visibleInputs.length > 0) {
        return parseInt(visibleInputs[0].value, 10) || 1;
      }
      
      // Fallback sur les anciennes sélections
      const q3 = document.getElementById("variantQuantity");
      return (q3 && parseInt(q3.value, 10)) || 1;
    }

    const variantCount = parseInt(me.getAttribute("size") || "0", 10);

    if (variantCount === 1) {
      const variantId = me.getAttribute("variantId");
      const qty = me.getAttribute("main-product") ? getContextQuantity() : 1;
      addItemAndUpdate(variantId, qty, true);
      return false;
    }

    if (variantCount > 1) {
      $("#main-cart-items").attr("style", "display:none!important;");
      $("#main-cart-footer").attr("style", "display:none!important;");
      $("#variantPicker").hide();

      fetch(me.getAttribute("href"))
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");

          const radiosPicker = doc.querySelector(
            "#variant-radios fieldset, #radiosPicker fieldset, variant-radios fieldset, [data-section-type='product'] fieldset"
          );
          if (!radiosPicker) return;

          const productTitle = doc.querySelector(
            "h1.product__title, .product__title, .product__information h1"
          );
          const productPrice = doc.querySelector(
            ".price-item--regular, .product__price, .price__container .price-item"
          );

          if (productTitle)
            $("#product__title_picker").text(productTitle.textContent.trim());
          if (productPrice)
            $("#product__price_picker").html(productPrice.innerHTML);

          $("#product__variant_picker").html(radiosPicker);

          if ($("#variantAddToCart").length === 0) {
            const addToCartLabel = "{{ 'products.product.add_to_cart' | t }}";
            $("#product__variant_picker").after(
              `<button id="variantAddToCart" class="button button--primary" style="margin-top:10px;">${addToCartLabel}</button>`
            );
          }

          $("#variantPicker").show();
          expandCart();

          $(document)
            .off("click", ".variant-picker-label")
            .on("click", ".variant-picker-label", function () {
              const available = $(this).attr("available") !== "false";
              if (available) window.__lastVariantId = $(this).attr("id");
            });

          $("#variantAddToCart")
            .off("click")
            .on("click", function () {
              const chosen =
                window.__lastVariantId ||
                $(".variant-picker-label[available!='false']").first().attr("id");
              const qty = getContextQuantity();

              $("#variantPicker").hide();
              $("#main-cart-items").attr("style", "display:none!important;");
              $("#main-cart-footer").attr("style", "display:none!important;");

              addItemAndUpdate(chosen, qty, true, function () {
                $("#main-cart-items").attr("style", "display:block!important;");
                $("#main-cart-footer").attr("style", "display:flex!important;");
              });
            });
        })
        .catch(() => {});

      return false;
    }

    return false;
}

window.check = check;

/* ===========================================================
   Gestion spinner classique (boutons recommandation)
=========================================================== */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".vv-add-to-cart").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.classList.contains("loading")) return;
      btn.classList.add("loading");
      setTimeout(() => btn.classList.remove("loading"), 1500);
    });
  });
});

/* ===========================================================
   Reset visuel quand panier mis à jour
=========================================================== */
document.addEventListener("cart:updated", function () {
  document.querySelectorAll(".vv-add-to-cart.loading")
    .forEach((btn) => btn.classList.remove("loading"));
});
